import { useState, useEffect } from 'react';
import { chipchipDatabaseService } from '@/services/chipchip/chipchipDatabaseService';

interface ChipChipOrderData {
  date: string;
  orderCount: number;
}

export const useChipChipOrders = (
  productName: string,
  startDate: string,
  endDate: string,
  frequency: 'daily' | 'weekly' | 'monthly' = 'daily'
) => {
  const [orderData, setOrderData] = useState<ChipChipOrderData[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOrderData = async () => {
      if (!productName || !startDate || !endDate) {
        setOrderData([]);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const data = await chipchipDatabaseService.fetchChipChipOrderCounts(
          productName,
          startDate,
          endDate,
          frequency
        );
        setOrderData(data);
      } catch (err) {
        console.error('Error fetching ChipChip order data:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch order data');
        setOrderData([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOrderData();
  }, [productName, startDate, endDate, frequency]);

  return { orderData, isLoading, error };
};